export default {"src":"/_next/static/media/ic-twitch-channel.bdda052b.svg","height":20,"width":20};